import { FormControl, InputLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import styles from "../Cadastro.module.css";
import InputMask from "react-input-mask";
import { UF } from "../../../../components/Combobox/UF";
import { CidadesSearchField } from "../../../../components/Searchfields/Cidades";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Tooltip } from "@mui/material";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { faExpand, faCompress, faArrowRightArrowLeft, faCompass, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import Maps from "../../../../components/Maps/Maps";
import servParam from "../../../../services/login/servParam";
import { OpcoesUF } from "../../../../components/Combobox/UF";
import { EnumStatusChaveApiGoogle } from "../../../../infra/utils/Enums";

const Localizacao = ({ setIsLoading, setOpenError, setErrorMessage, camposDesabilitados, codigoUc, camposDesabilitadosUc, onKeyDown, podeSalvar }) => {
    const { control, getValues, setValue, formState: { errors } } = useFormContext();
    const [disponibilizaMapa, setDisponibilizaMapa] = useState(0);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
    const [chaveApiGoogle, setChaveApiGoogle] = useState("");
    const [hiddenEnderecos, setHiddenEnderecos] = useState(false);
    const [coordenadaSalva, setCoordenadaSalva] = useState(null);
    const [updateKey, setUpdateKey] = useState(0);
    const [hiddenCamposNaoAutorizados, setHiddenCamposNaoAutorizados] = useState(true);

    useEffect(() => {
        recuperarParametros();

        if (getValues("Latitude") && getValues("Longitude")) {
            setCoordenadaSalva({ lat: getValues("Latitude"), lng: getValues("Longitude") });
        } else {
            setCoordenadaSalva(null);
        }
    }, []);

    useEffect(() => {
        validarChaveApi(chaveApiGoogle);
    }, [chaveApiGoogle]);

    const onClickRetornarCoordenadas = () => {
        setCoordenadaSalva(null);
        setUpdateKey(prevKey => prevKey + 1);
    };

    const onClickSetEndereco = async () => {
        try {
            const { lat, lng } = coordinates;
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${chaveApiGoogle}`;
            const response = await axios.get(url);
            const dados = response.data;

            if (dados.status === 'OK') {
                const resultado = dados.results[0];
                const componentes = resultado.address_components;

                const endereco = {
                    cidade: componentes.find(c => c.types.includes('administrative_area_level_2'))?.long_name,
                    bairro: componentes.find(c => c.types.includes('sublocality'))?.long_name,
                    rua: componentes.find(c => c.types.includes('route'))?.long_name,
                    numero: componentes.find(c => c.types.includes('street_number'))?.long_name,
                    cep: componentes.find(c => c.types.includes('postal_code'))?.long_name,
                    uf: componentes.find(c => c.types.includes('administrative_area_level_1'))?.short_name
                };

                setValue("Endereco", endereco.bairro || "");
                setValue("Rua", endereco.rua || "");
                setValue("NumeroEnd", endereco.numero || 0);
                setValue("CEP", endereco.cep || "");
                setValue("UF", {
                    value: endereco.uf,
                    label: OpcoesUF.find((opcao) => opcao.value == endereco.uf).label
                });

                setValue("Latitude", lat);
                setValue("Longitude", lng);
            } else {
                console.error('Erro ao buscar dados:', dados.status);
            }
        } catch (erro) {
            console.error('Erro na requisição:', erro);
        }
    };

    const recuperarParametros = async () => {
        try {
            setIsLoading(true);
            const params = await servParam.recuperarGDParametros();

            setDisponibilizaMapa(params.Content.UsaMapas);
            setChaveApiGoogle(params.Content.ChaveGoogle);
            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);
            console.log("erro" + err);
        }
    };

    const onChangeCoordinates = (coords) => {
        setCoordinates(coords);
    };

    const onClickSetCoordenadas = () => {
        setValue("Latitude", coordinates.lat);
        setValue("Longitude", coordinates.lng);
    };

    const onClickSetFullscreenControl = () => {
        setHiddenEnderecos(prevState => !prevState);
    };

    const validarChaveApi = async (chaveApiGoogle) => {
        try {
            if(chaveApiGoogle) {
                const response = await servParam.validarChaveApi(chaveApiGoogle);
                
                if(response.Content?.Content === EnumStatusChaveApiGoogle.NAO_AUTORIZADO) {
                    setHiddenCamposNaoAutorizados(true);
                }else {
                    setHiddenCamposNaoAutorizados(false);
                }
            }
        } catch (err) {
            setIsLoading(false)
            console.log("erro" + err);
        }
    }

    return (
        <Container sx={{ mt: 2, display: "flex", alignItems: "center", width: "100%" }}>
        {Boolean(disponibilizaMapa) && (
            <div style={{ display: "flex" }}>
                <Maps codigoUc={codigoUc} onChangeCoordinates={onChangeCoordinates} hiddenEnderecos={hiddenEnderecos} coordenadaSalva={coordenadaSalva} updateKey={updateKey} disabled={!podeSalvar} hiddenCamposNaoAutorizados={hiddenCamposNaoAutorizados}/>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", margin: hiddenCamposNaoAutorizados ? "45px 0px 0px 28px" : "120px 0px 0px 28px", height: "24vh" }}>
                    <Tooltip title={hiddenEnderecos ? "Recolher mapa" : "Expandir mapa"} arrow>
                        <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickSetFullscreenControl} disabled={!podeSalvar}>
                            <FontAwesomeIcon icon={!hiddenEnderecos ? faExpand : faCompress}  style={{ color: !podeSalvar ? 'rgba(0, 0, 0, 0.26)' : "white" }}/>
                        </BlueHoverButton>
                    </Tooltip>
                    {!hiddenCamposNaoAutorizados && (
                        <Tooltip title="Preencher dados de endereço conforme mapa" arrow >
                            <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickSetEndereco} disabled={!podeSalvar || camposDesabilitados || camposDesabilitadosUc}>
                                <FontAwesomeIcon icon={faArrowRightArrowLeft}  style={{ color: !podeSalvar || camposDesabilitados || camposDesabilitadosUc ? 'rgba(0, 0, 0, 0.26)' : "white" }}/>
                            </BlueHoverButton>
                        </Tooltip>
                    )}
                    <Tooltip title="Preencher coordenadas conforme mapa" arrow >
                        <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickSetCoordenadas} disabled={!podeSalvar}>
                            <FontAwesomeIcon icon={faCompass}  style={{ color: !podeSalvar ? 'rgba(0, 0, 0, 0.26)' : "white" }}/>
                        </BlueHoverButton>
                    </Tooltip>
                    <Tooltip title="Retornar coordenadas da UC ou cidade padrão" arrow >
                            <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickRetornarCoordenadas} disabled={!podeSalvar}>
                                <FontAwesomeIcon icon={faRotateLeft}  style={{ color: !podeSalvar ? 'rgba(0, 0, 0, 0.26)' : "white" }}/>
                            </BlueHoverButton>
                    </Tooltip>
                </div>
            </div>
        )}
        {!hiddenEnderecos && (
             <div style={{ width: "100%" }}>
             <div className={styles['input-container']}>
 
                 <Controller 
                     name="CodigoCidade"
                     control={control}
                     render={({field}) => (
                         <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 3 }}>
                             <InputLabel htmlFor="consulta-cidade" shrink sx={{ color: "#b8b8b8" }}>Cidade <FontAwesomeIcon title="Para facilitar a procura, digite o nome da cidade desejada no campo abaixo." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></InputLabel>
                             <CidadesSearchField
                                 field={field}
                                 id="consulta-cidade" 
                                 setOpenError={setOpenError}
                                 setErrorMessage={setErrorMessage}
                                 disabled={camposDesabilitados || camposDesabilitadosUc} 
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.Cidade ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.Cidade ?  (
                                     <HelperText text={errors?.Cidade?.message} />
                             ) : '' }
                         </FormControl>
                     )}
                 />
 
                 <Controller 
                     name="Endereco"
                     control={control}
                     render={({field}) => (
                         <FormControl variant="outlined" className={styles['campos-m']} >
                             <InputLabel htmlFor="consulta-endereco" shrink sx={{ color: "#b8b8b8" }}>Bairro</InputLabel>
                             <WhiteInput
                                 fullWidth 
                                 placeholder="Bairro" 
                                 type="text" 
                                 id="consulta-endereco" 
                                 name="Bairro" 
                                 {...field} 
                                 readOnly={camposDesabilitados || camposDesabilitadosUc} 
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.Endereco ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.Endereco ?  (
                                     <HelperText text={errors?.Endereco?.message} />
                             ) : '' }
                         </FormControl>
                     )}
                 />
 
 
             </div>
             <div className={styles['input-container']}>
                 <Controller 
                     name="Rua"
                     control={control}
                     render={({ field }) => (
                         <FormControl variant="outlined" className={styles['campos-m']} >
                             <InputLabel htmlFor="consulta-rua" shrink sx={{ color: "#b8b8b8" }}>Rua</InputLabel>
                             <WhiteInput
                                 fullWidth 
                                 placeholder="Rua" 
                                 type="text" 
                                 id="consulta-rua" 
                                 name="Rua" 
                                 {...field} 
                                 readOnly={camposDesabilitados || camposDesabilitadosUc} 
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.Rua ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.Rua ?  (
                                     <HelperText text={errors?.Rua?.message} />
                             ) : '' }
                         </FormControl>
                     )} 
                 />
 
                 <Controller 
                     name="NumeroEnd"
                     control={control}
                     render={({field}) => (
                         <FormControl variant="outlined" className={styles['campos-m']} >
                             <InputLabel htmlFor="consulta-numeroEnd" shrink sx={{ color: "#b8b8b8" }}>Nº Endereço</InputLabel>
                             <WhiteInput
                                 fullWidth 
                                 placeholder="Nº Endereço" 
                                 type="number" 
                                 id="consulta-numeroEnd" 
                                 name="NumeroEndereco" 
                                 {...field} 
                                 readOnly={camposDesabilitados || camposDesabilitadosUc} 
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.NumeroEnd ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.NumeroEnd ?  (
                                     <HelperText text={errors?.NumeroEnd?.message} />
                             ) : '' }
                         </FormControl>
                     )}
                 />
             </div>
 
             <div className={styles['input-container']}>
 
                 <Controller 
                     name="CEP"
                     control={control}
                     render={({ field: { onChange, value }}) => (
                         <FormControl variant="outlined" className={styles['campos-m']} >
                             <InputLabel htmlFor="consulta-cep" shrink sx={{ color: "#b8b8b8" }}>CEP</InputLabel>
                             <InputMask
                                 mask="99999-999"
                                 onChange={onChange}
                                 value={value}
                                 id="consulta-cep"
                                 readOnly={camposDesabilitados || camposDesabilitadosUc}
                             >
                                 { inputProps => (
                                     <WhiteInput
                                         fullWidth 
                                         placeholder="CEP"
                                         name="Cep" 
                                         {...inputProps}
                                         onKeyDown={onKeyDown}
                                         className={`${errors?.CEP ? styles.campoComValorErrado : ""}`}
                                         readOnly={camposDesabilitados || camposDesabilitadosUc}
                                     />
                                 )}
                             </InputMask>
                             { errors?.CEP ?  (
                                     <HelperText text={errors?.CEP?.message} />
                             ) : '' }
                         </FormControl>
                     )} 
                 />
 
 
 
                 <Controller 
                     name="UF"
                     control={control}
                     render={({ field }) => (
                         <FormControl variant="outlined" className={styles['campos-m']} >
                             <InputLabel htmlFor="consulta-uf" shrink sx={{ color: "#b8b8b8" }}>UF</InputLabel>
                             <UF 
                                 field={field}
                                 id="consulta-uf"
                                 name="Consulta UF"
                                 placeholder="Selecione um estado"
                                 readOnly={camposDesabilitados || camposDesabilitadosUc}
                                 disabled={camposDesabilitados || camposDesabilitadosUc}
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.UF ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.UF ?  (
                                     <HelperText text={errors?.UF?.value?.message} />
                             ) : '' }
                         </FormControl>
                     )} 
                 />
             </div>

             <div className={styles['input-container']}>
                        <Controller
                            name="Latitude"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="consulta-Latitude" shrink sx={{ color: "#b8b8b8" }}>Latitude</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Latitude"
                                        id="consulta-Latitude"
                                        name="Latitude" {...field}
                                        readOnly={!podeSalvar}
                                    />
                                    {errors?.Latitude && (
                                        <HelperText text={errors?.Latitude?.message} />
                                    )}
                                </FormControl>
                            )}
                        />

                        <Controller
                            name="Longitude"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="consulta-Longitude" shrink sx={{ color: "#b8b8b8" }}>Longitude</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Longitude"
                                        id="consulta-Longitude"
                                        name="Longitude" {...field}
                                        readOnly={!podeSalvar}
                                    />
                                    {errors?.Longitude && (
                                        <HelperText text={errors?.Longitude?.message} />
                                    )}
                                </FormControl>
                            )}
                        />
                    </div>
 
             <div className={styles['input-container']}>
                 <Controller 
                     name="Complemento"
                     control={control}
                     render={({field}) => (
                         <FormControl variant="outlined" className={styles['campos-g']} >
                             <InputLabel htmlFor="consulta-complemento" shrink sx={{ color: "#b8b8b8" }}>Complemento</InputLabel>
                             <WhiteInput
                                 fullWidth 
                                 placeholder="Complemento" 
                                 type="text" 
                                 id="consulta-complemento" 
                                 name="Complemento" 
                                 {...field} 
                                 readOnly={camposDesabilitados || camposDesabilitadosUc} 
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.Complemento ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.Complemento ?  (
                                     <HelperText text={errors?.Complemento?.message} />
                             ) : '' }
                         </FormControl>
                     )}
                 />
                 
             </div>
         </div>
        )}
    </Container>

      
    );
}

export { Localizacao }